const translations = {
    es: {
        "url_1": "URL 1",
        "url_1.description": "URL 1 del servidor NTP.",
        "url_2": "URL 2",
        "url_2.description": "URL 2 del servidor NTP.",
        "url_3": "URL 3",
        "url_3.description": "URL 3 del servidor NTP.",
        "url_4": "URL 4",
        "url_4.description": "URL 4 del servidor NTP.",
        "ntp_server": "Servidor NTP",
        "ntp_server.description": "Servidor NTP a utilizar (htts:/example.com:123).",
        "tz": "Zona horaria",
        "tz.description": "Zona horaria cada unidad representa 15 minutos. (ejemplo: tz=4 es 60min)",
        "sync": "Sincronizar",
        "sync.description": "Dias entre intentos de sincronización.",
        // -
        "create.title": "Crear configuración de NTP",
        "edit.title": "Editar configuración de NTP",
    },
    en: {
        "url_1": "URL 1",
        "url_1.description": "URL 1 of the NTP server.",
        "url_2": "URL 2",
        "url_2.description": "URL 2 of the NTP server.",
        "url_3": "URL 3",
        "url_3.description": "URL 3 of the NTP server.",
        "url_4": "URL 4",
        "url_4.description": "URL 4 of the NTP server.",

        // -
        "create.title": "Create NTP configuration",
        "edit.title": "Edit NTP configuration",
    },
};

export default translations;
